import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';

import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import { ReportsContext } from '../../../context';
import {
  SHIP_DATE_PICKER_PROPS,
  LABEL_PROVIDER_PROPS,
  SHIPPING_ACCOUNT_PROPS,
  SHIP_FROM_PICKER_PROPS,
} from '../../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';
import messages from './messages';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_CSV];

const ShippingManifest = () => {
  const { labelProviderId, myAccountsForProvider } = useContext(ReportsContext);
  const hasProviderSelected = !!labelProviderId;
  const multiSelections = [
    {
      name: <FormattedMessage {...messages.selectAccount} />,
    },
    ...myAccountsForProvider,
  ];

  const shippingAccountProps = {
    ...SHIPPING_ACCOUNT_PROPS,
    disabled: !hasProviderSelected,
    options: myAccountsForProvider.length > 1 ? multiSelections : myAccountsForProvider,
  };
  const filtersProps = [SHIP_DATE_PICKER_PROPS, LABEL_PROVIDER_PROPS, shippingAccountProps, SHIP_FROM_PICKER_PROPS];
  const updatedFiltersProps = useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual);
  return (
    <>
      <ReportFilters filtersProps={updatedFiltersProps} />
      <ReportActions actions={actions} />
    </>
  );
};

export default ShippingManifest;
